<template>
  <div id="login" align-h="center">
    <b-overlay :show="loading" rounded="sm" no-wrap fixed />
    <br />
    <br />
    <b-container>
      <b-row cols="3">
        <b-col></b-col>
        <b-col>
          <b-card
            class="text-center"
            bg-variant="light"
            title="Cost Benefit Analysis Tool"
            sub-title="School Infrastructure NSW"
          >
            <template v-slot:header>
              <!-- <b-img
            blank-color="rgb(50, 63, 72)"
            src="@/assets/seim-logo.png"
            style="max-height: 200px; margin-top: 0.8em"
          /> -->
            </template>
            <b-button variant="sgs-green" :href="`/staff/login`">
              Login as staff
            </b-button>
            <hr />
            <br />
            <b-form @submit.prevent="login">
              <b-form-group label-cols="4">
                <template v-slot:label> Project ID </template>
                <b-input
                  v-model="username"
                  type="text"
                  placeholder="Enter project id"
                  required
                ></b-input>
              </b-form-group>
              <b-form-group label-cols="4">
                <template v-slot:label> Password </template>
                <b-input
                  v-model="password"
                  type="password"
                  placeholder="Enter password"
                  required
                ></b-input>
              </b-form-group>
              <br />

              <b-button variant="primary" type="submit">Login</b-button>
            </b-form>
          </b-card>
          <br />
          <b-alert
            v-if="successMessage"
            class="text-center"
            variant="success"
            show
            >{{ successMessage }}</b-alert
          >
          <b-alert v-if="serverError" show variant="danger" class="text-center">
            {{ serverError }}
          </b-alert>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "login",
  props: {
    dataSuccessMessage: {
      type: String,
    },
  },
  data() {
    return {
      username: "",
      password: "",
      serverError: "",
      successMessage: this.dataSuccessMessage,
      loading: false,
    };
  },
  methods: {
    login() {
      this.loading = true;
      this.$store
        .dispatch("retrieveTokenExternal", {
          username: this.username,
          password: this.password,
        })
        .then((response) => {
          this.loading = false;
          console.log(response.data);
          this.$router.push({
            path: "/project/" + response.data.public_id,
          });
          // this.successMessage = response.data;
        })
        .catch((error) => {
          console.log(error.response.status);
          this.loading = false;
          this.serverError = error.response.data;
          this.password = "";
          this.successMessage = "";
        });
    },
  },
  mounted() {
    this.serverError = this.$route.params.error;
  },
};
</script>

<style scoped>
.server-error {
  color: red;
}

.card-header {
  background-color: rgb(50, 63, 72);
}
</style>
